import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" ログイン ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        block: "",
                        size: "large",
                        class: "text-none",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$store.dispatch('auth/loginWithGoogle')))
                      }, {
                        prepend: _withCtx(() => [
                          _createElementVNode("img", {
                            alt: "Vue logo",
                            height: "20",
                            src: require('../assets/google.svg')
                          }, null, 8, _hoisted_1)
                        ]),
                        default: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createTextVNode(" Googleでログイン ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        block: "",
                        size: "large",
                        color: "#55acee",
                        class: "text-white text-none",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$store.dispatch('auth/loginWithTwitter')))
                      }, {
                        prepend: _withCtx(() => [
                          _createElementVNode("img", {
                            alt: "Vue logo",
                            height: "20",
                            src: require('../assets/twitter.svg')
                          }, null, 8, _hoisted_2)
                        ]),
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createTextVNode(" Twitterでログイン ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}